// Helper to detect MIME type from base64 data
export const detectMimeType = (base64: string): string => {
  if (!base64) return 'image/jpeg';
  if (base64.startsWith('/9j/')) return 'image/jpeg';
  if (base64.startsWith('iVBORw')) return 'image/png';
  if (base64.startsWith('R0lGOD')) return 'image/gif';
  if (base64.startsWith('UklGR')) return 'image/webp';
  return 'image/jpeg'; // Default to JPEG (most common from A4F API)
};

// Helper to get file extension from MIME type
export const getExtensionFromMime = (mimeType: string): string => {
  if (mimeType.includes('jpeg') || mimeType.includes('jpg')) return 'jpg';
  if (mimeType.includes('png')) return 'png';
  if (mimeType.includes('gif')) return 'gif';
  if (mimeType.includes('webp')) return 'webp';
  return 'jpg'; // Default to jpg
};

// Build a proper data URL from raw base64
export const buildImageDataUrl = (base64: string): string => {
  if (!base64) return '';
  if (base64.startsWith('data:image/')) return base64;
  const mimeType = detectMimeType(base64);
  return `data:${mimeType};base64,${base64}`;
};

// Get display URL for an image object - handles various formats
export const getImageDisplayUrl = (image: { image_url?: string; b64_json?: string; url?: string }): string => {
  // Priority 1: b64_json with correct MIME detection
  if (image.b64_json && image.b64_json.length > 10) {
    return buildImageDataUrl(image.b64_json);
  }
  
  // Priority 2: url field (queue items)
  if (image.url && image.url.startsWith('data:image/')) {
    return image.url;
  }
  
  // Priority 3: image_url if it's a valid data URL (not "base64" placeholder)
  if (image.image_url && 
      image.image_url !== 'base64' && 
      image.image_url.startsWith('data:image/')) {
    return image.image_url;
  }
  
  // Fallback for external URLs
  if (image.image_url && 
      image.image_url !== 'base64' && 
      (image.image_url.startsWith('http://') || image.image_url.startsWith('https://'))) {
    return image.image_url;
  }
  
  return '';
};
